import BaseModel from './BaseModel';
import { CompanyLocationModel } from './LocationModels';

class PolicyholderEquipmentModel extends BaseModel {
  init(data) {
    this.id = data.id || 0;
    this.name = data.name || '';
    this.location = data.location ? new CompanyLocationModel(data.location) : null;
    this.lastService = data.last_service ? this.stringToDate(data.last_service) : null;
    this.requestsOpenTotal = data.requests_open_total || 0;
    this.workOrdersTotal = data.work_orders_total || 0;
    this.workOrdersCompletedThisYear = data.work_orders_completed_this_year || 0;
  }
}

export default PolicyholderEquipmentModel;
